import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import { Chat } from "..";
import "../../../assets/css/chatBox.css";

const useStyles = makeStyles((theme) =>
  createStyles({
    chats: {
      height: 200, //元々のBOX(c-boxなどのheightから計算してぴったりにする)
      padding: "0",
      overflow: "auto",
      //   backgroundColor: "red",
    },
  })
);

const Chats = (props) => {
  // console.log(props.chats);
  const classes = useStyles();
  return (
    <List className={classes.chats} id={"scroll-area"}>
      {props.chats.map((chat, index) => {
        return (
          <Chat
            message={chat.message}
            sendId={chat.sendId}
            sendName={chat.sendName}
            avatar={chat.avatar}
            key={index.toString()}
          />
        );
      })}
    </List>
  );
};
export default Chats;
